import { LOGIN_SUCCESS, LOGOUT, LOGIN_FAIL, LOAD_USER } from '../actions/types';
import tokenStorage from "~/services/tokenStorage";
import {AUTH_TOKEN} from "~/services/http/axios";

const initialState = {
  isAuthenticated: !!tokenStorage.getItem(AUTH_TOKEN),
  user: null,
  loaded: false,
};

export default function (state = initialState, action) {

  const { payload, type } = action

  switch (type) {
    case LOGIN_SUCCESS:
      return {
        ...state,
        isAuthenticated: true,
        loaded: true
      };

    case LOAD_USER:
      return {
        ...state,
        user: payload,
        isAuthenticated: payload && payload.id,
        loaded: true
      };

    case LOGIN_FAIL:
    case LOGOUT:
      return {
        ...state,
        isAuthenticated: false,
        user: null
      };

    default:
      return state;
  }
}
